import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/dashboard/dashboard-page';
import { useFeature } from '@/features/feature-flags/use-feature';
import { homeTexts } from '@/features/home/texts';

export const Route = createFileRoute('/_app/')({
  component: HomePage,
});

/** Start page: the role-based overview (DASH-01..06) while the flag `dashboard` is on. */
function HomePage() {
  const dashboard = useFeature('dashboard');
  if (dashboard) return <DashboardPage />;
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold">{homeTexts.title}</h1>
        <p className="text-muted-foreground mt-1">{homeTexts.intro}</p>
      </div>
    </div>
  );
}
